<template>
  <div class="shareholders">
    <Table :columns="_i18n.locale === 'en' ? columns_en : columns_al" :data="_i18n.locale === 'en' ? data_en : data_al" ref="table" />
    <Button type="primary" shape="circle"  @click="exportData()" name="CSV">
      <Icon type="ios-download-outline" :size="22"></Icon>
    </Button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns_en: [
        {
          title: 'Name',
          key: 'name',
        },
        {
          title: 'Shares',
          key: 'shares',
          align: 'right',
        },
      ],
      columns_al: [
        {
          title: 'Emri',
          key: 'name',
        },
        {
          title: 'Aksionet',
          key: 'shares',
          align: 'right',

        },
      ],
      data_al: [
        {
          name: 'Favera Holding sh.a.',
          shares: '99.64%',
        },
        {
          name: 'Aksionarët tjerë',
          shares: '0.36%',
        },
      ],
      data_en: [
        {
          name: 'Favera Holding sh.a.',
          shares: '99.64%',
        },
        {
          name: 'Other shareholders',
          shares: '0.36%',
        },
      ],
    };
  },
  methods: {
    exportData() {
      this.$refs.table.exportCsv({
        filename: 'Shareholders',
      });
    },
  },
};
</script>

<style lang="scss">
.shareholders {
  button {
    margin-top: 20px;
    margin-left: auto;
    display: block;
  }
}
</style>
